import type { CORNERS, LAYOUT, SHADOW } from 'vars/index'

import { styled } from '@linaria/react'
import { ButtonSC } from 'atoms/Button'
import { IconSC } from 'atoms/Icon'
import { TVShowCardWithDescriptionSC } from 'blocks/Cards/TVShowCardWithDescription/TVShowCardWithDescription.styled'
import { COLOR, FIXED_INDENTS, MEDIA } from 'vars/index'

export const TitleSC = styled.div`
  ${MEDIA.MAX_599} {
    max-width: 92%;
  }
  ${MEDIA.MIN_600} {
    max-width: 100%;
  }

  ${ButtonSC} {
    gap: var(${FIXED_INDENTS.INDENT_30});

    ${MEDIA.MIN_600} {
      gap: var(${FIXED_INDENTS.INDENT_40});
    }

    ${IconSC} {
      margin: 0;
    }
  }
`

export const PlaylistPopUpSC = styled.div<{
  backgroundColor?: COLOR
  shadow?: SHADOW
  horizontalPaddings?: LAYOUT | FIXED_INDENTS
  corners?: CORNERS
}>`
  --scrollbar-width: 6px;

  ${MEDIA.MAX_599} {
    width: 100vw;
    height: 100dvh;
    right: 0;
    bottom: 0;
    border-radius: 0;
  }

  ${MEDIA.MIN_600} {
    right: 24px;
    bottom: 64px;
    width: 506px;
    max-height: calc(100% - 64px);
  }

  ${MEDIA.MIN_1240} {
    right: 64px;
    bottom: 96px;
    max-height: calc(100% - 96px);
  }

  position: absolute;
  display: flex;
  flex-direction: column;

  width: 506px;
  height: 70vh;
  background-color: var(${COLOR.BACKGROUND_DARK});
  border-radius: ${({ corners }) => `var(${corners})`};

  overflow: hidden;
  isolation: isolate;
  z-index: 3;
`

export const PlaylistPopoverHeaderSC = styled.div<{
  isTopNotReached: boolean
}>`
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 var(${FIXED_INDENTS.INDENT_50});

  ${MEDIA.MIN_600} {
    padding: 0 var(${FIXED_INDENTS.INDENT_60});
  }

  ${MEDIA.MIN_1240} {
    padding: 0 var(${FIXED_INDENTS.INDENT_80});
  }

  border-bottom: ${({ isTopNotReached }) =>
    isTopNotReached ? `1px solid var(${COLOR.SURFACE_DARK_6})` : 'none'};

  > :last-child {
    // hides close button
    ${MEDIA.MIN_1240} {
      display: none;
    }
  }
`

export const PopoverGradientOverlay = styled.div<{
  isBottomNotReached: boolean
}>`
  display: flex;
  flex: 1;
  min-height: 1px;
  position: relative;
  flex-direction: column;

  &:before,
  &:after {
    content: '';
    position: absolute;
    width: calc(100% - var(--scrollbar-width));
    height: 3.5rem;
    z-index: 2;
  }

  &:after {
    display: ${({ isBottomNotReached }) =>
      isBottomNotReached ? 'block' : 'none'};
    bottom: 0;
    background: var(${COLOR.MAIN_GRADIENT_0});
  }
`

export const PlaylistScrollableBlockSC = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;

  ${TVShowCardWithDescriptionSC} {
    &:first-of-type {
      margin-top: 3px;
    }
  }

  &::-webkit-scrollbar {
    width: var(--scrollbar-width);
  }

  &::-webkit-scrollbar-thumb {
    background: var(${COLOR.SURFACE_DARK_7});
    cursor: pointer;
    border-right: 2px solid var(${COLOR.BACKGROUND_DARK});
    border-bottom: 2px solid var(${COLOR.BACKGROUND_DARK});
    border-top: 2px solid var(${COLOR.BACKGROUND_DARK});
    border-top-left-radius: 2px 4px;
    border-bottom-left-radius: 2px 4px;
    border-top-right-radius: 4px 4px;
    border-bottom-right-radius: 4px 4px;
  }
`
